import {
  Avatar,
  Box,
  Typography,
  makeStyles,
  IconButton,
} from "@material-ui/core";
import React from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  VideoCardsBox: {
    background: "rgba(255, 255, 255, 0.03)",
    borderRadius: "10px",
    margin: "0px 4px",
    cursor: "pointer",
    // width: "calc(100% - 23px)",
    position: "relative",
    height: "100%",
    "& .videocontentBox": {
      padding: "20px",
    },
  },
  mainimg: {
    width: "100%",
    overflow: "hidden",
    position: "relative",
    backgroundPosition: "center !important",
    backgroundSize: "cover !important",
    backgroundRepeat: " no-repeat !important",
    borderRadius: "10px",
  },
}));

export default function VideoCards({ value, index }) {
  const classes = useStyles();
  const history = useHistory();

  const updateDimensions = () => {
    var offsetWidth = document.getElementById("imagecard" + index).offsetWidth;
    var newoofsetWidth = offsetWidth - 80;
    document.getElementById("imagecard" + index).style.height =
      newoofsetWidth + "px";
  };
  const updateDimensionsForTextCArd = () => {
    var offsetWidth = document.getElementById("textCard" + index).offsetWidth;
    var newoofsetWidth = offsetWidth - 20;
    document.getElementById("textCard" + index).style.height =
      newoofsetWidth + "px";
  };

  useEffect(() => {
    updateDimensions();
    updateDimensionsForTextCArd();
  }, [value, index]);
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);
  return (
    <Box
      className={classes.VideoCardsBox}
      onClick={() =>
        history.push({
          pathname: "/news-details",
          search: value._id,
        })
      }
    >
      <Box
        id={`imagecard${index}`}
        className={classes.mainimg}
        style={
          value?.thumbnail && value?.thumbnail !== "undefined"
            ? {
                background: "url(" + value?.thumbnail + ")",
              }
            : { background: "url(images/banner_center.png)" }
        }
      ></Box>

      <Box id={`textCard${index}`} className="videocontentBox">
        {/* <Typography
          variant="body1"
          style={{ color: "rgba(255, 255, 255, 0.25)", fontSize: "12px" }}
          className="dmMono"
        >
          {value?.title}
        </Typography> */}
        <Box mt={2} mb={2}>
          <Typography
            variant="h4"
            color="primary"
            style={{ wordWrap: "break-word" }}
          >
            {value?.title}
          </Typography>
        </Box>

        <Typography
          variant="body1"
          style={{ color: "rgba(255, 255, 255, 0.25)" }}
          className="dmMono"
        >
          <div
            dangerouslySetInnerHTML={{
              __html:
                value?.description?.length > 200
                  ? `${value?.description.slice(0, 300)}....`
                  : value?.description,
            }}
          />
        </Typography>
      </Box>
    </Box>
  );
}
